import { createElement } from "react";

/**
 * Global fallback for `notFound()` throws that no route handles itself. The
 * deleted legacy segments (REMOVED_OWNER_SEGMENTS) land here via the
 * entity-type and entity-splat guards, and old bookmarks and chat messages may
 * still contain those URLs. Without this, TanStack renders a bare unstyled
 * "Not Found" paragraph.
 *
 * Wired as `defaultNotFoundComponent` on both the real router (`src/router.ts`)
 * and the test harness router (`src/test/render.tsx`) so route smokes exercise
 * the same not-found surface production serves. The plain anchor keeps this
 * router-level fallback independent of router context.
 */
export function GlobalNotFound() {
	return createElement(
		"div",
		{
			className:
				"flex min-h-[60vh] flex-col items-center justify-center gap-3 px-4 text-center",
		},
		createElement(
			"h1",
			{ className: "text-2xl font-semibold" },
			"Page not found",
		),
		createElement(
			"p",
			{ className: "text-muted-foreground" },
			"This page no longer exists — it may be an old link.",
		),
		createElement(
			"a",
			{
				href: "/",
				className: "text-primary underline underline-offset-4",
			},
			"Go home",
		),
	);
}
